import ExclamationTriangleIcon from "./exclamationTriangle.icon";

export default function ErrorCenterIcon({ reason }: { reason: any }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-red-400">
      <ExclamationTriangleIcon className="w-20 h-20" />
      {getErrorMessage(reason)}
    </div>
  );
}

function getErrorMessage(reason: any) {
  if (!reason) return null;
  if (reason.message) return reason.message;
  return JSON.stringify(reason);
}
